export function trackId(index: number, { id }: { id: string }) {
	return id;
}
export function trackByProp(prop: string) {
	return (index: number, data: { [key: string]: string }) => {
		return data[prop] ?? index;
	};
}
